export default __webpack_public_path__ + "static/media/SortAscending.11de7d8e.svg";